import React from 'react';
import { BadgeCheck, Shield, CheckCircle2, FileText, Users } from 'lucide-react';
import { trustSection } from '../mockData';

const iconMap = {
  BadgeCheck: BadgeCheck,
  Shield: Shield,
  CheckCircle2: CheckCircle2,
  FileText: FileText,
  Users: Users
};

const TrustSection = () => {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-br from-emerald-900 to-emerald-800 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Title */}
        <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white text-center mb-10 sm:mb-12">
          {trustSection.title}
        </h2>

        {/* Benefits Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 sm:gap-8 max-w-6xl mx-auto">
          {trustSection.benefits.map((benefit, index) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center group"
              >
                <div className="bg-amber-500 p-4 sm:p-6 rounded-full mb-3 sm:mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-xl">
                  <IconComponent className="h-6 w-6 sm:h-8 sm:w-8 text-emerald-950" />
                </div>
                <p className="text-white font-semibold text-sm sm:text-base lg:text-lg leading-snug">
                  {benefit.text}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Trust */}
        <div className="mt-10 sm:mt-12 text-center">
          <div className="inline-block bg-white/10 backdrop-blur-md px-6 sm:px-8 py-3 sm:py-4 rounded-full border border-white/20">
            <p className="text-emerald-50 text-sm sm:text-lg font-medium">
              ✓ Dipercayai oleh pelanggan di seluruh Sarawak
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
